import React from "react";
import Footer from "../../../components/Footer";

const Logistics = () => {
  return (
    <section className="bg-white pt-20">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* LEFT CONTENT */}
        <div className="px-6 sm:px-10 lg:px-16 py-12 lg:flex lg:items-center">
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-3">
              Industries →
            </p>

            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Cybersecurity for Logistics
            </h1>

            <p className="font-semibold text-gray-800 mb-6">
              The logistics industry runs on highly distributed, always-on
              systems spanning warehouses, fleets, cloud platforms, and partner
              networks across geographies—making it a prime target for cyber
              threats.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              The growing use of IoT, GPS, telematics, and connected fleet
              technologies has improved visibility and efficiency, but often
              without strong security controls, significantly increasing the
              attack surface.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              In logistics, a cyber incident doesn’t just impact IT systems—it
              can delay shipments, disrupt supply chains, expose customer data,
              and ripple across partners and customers in real time.
            </p>

            <p className="text-gray-600 mb-8 leading-relaxed">
              Organizations must secure complex integrations, maintain uptime,
              and protect data across a constantly moving and interconnected
              ecosystem.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              How can Synthera help?
            </h3>

            <ul className="space-y-4 mb-8">
              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Zero Trust for Third-Party Access:</strong> We
                  implement identity-centric security to ensure vendors and
                  partners only access the specific systems and data
                  required—nothing more.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>API & Integration Hardening:</strong> We secure the
                  digital connections between platforms by auditing and
                  monitoring APIs and integrations, preventing unauthorized data
                  access and supply chain compromise.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Real-Time IoT & Asset Protection:</strong> From GPS
                  trackers to warehouse automation systems, we monitor and
                  secure connected devices to detect anomalies and stop threats
                  before they impact physical operations.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Recovery & Continuity Planning:</strong> We help you
                  develop offline workflows and immutable backup strategies so a
                  cyber incident never brings your operations to a standstill.
                </p>
              </li>
            </ul>

            <p className="text-gray-700 font-semibold mb-8">
              Our promise is to protect the digital integrity of your supply
              chain so you can focus on delivering on your commitments with
              confidence and resilience.
            </p>

            {/* COOL LINK CTA */}
            <a
              href="/Contact"
              className="group inline-flex items-center gap-1 font-semibold text-green-700 hover:text-green-800 transition"
            >
              <span className="relative">
                Talk to an expert
                <span className="absolute left-0 -bottom-0.5 h-0.5 w-0 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </span>
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative hidden lg:block pt-10">
          <img
            src="https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1770613385/Logistics_u0uuwm.png"
            alt="Logistics Cyber Security"
            className="w-full h-full object-cover"
          />

          {/* GREEN OVERLAY (MATCHED WITH IMAGE OFFSET) */}
          {/* <div className="absolute top-10 left-0 right-0 bottom-0 bg-green-900/70"></div> */}
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default Logistics;
